const map = {
	"./android_qrcode.png": 722,
	"./arrow.png": 225,
	"./arrow_guide.png": 56,
	"./bg_joker.png": 657,
	"./icon.png": 379,
	"./icon_aiword.png": 178,
	"./icon_jk.png": 845,
	"./icon_joker.png": 919,
	"./icon_lolita.png": 207,
	"./icon_lotea.png": 309,
	"./icon_modern.png": 325,
	"./ios_qrcode.png": 368,
	"./ios_qrcode_aiword.png": 419,
	"./police.png": 106,
	"./snapshot.jpeg": 606,
	"./snapshot_aiword.png": 351,
	"./snapshot_jk.jpeg": 369,
	"./snapshot_joker.jpeg": 973,
	"./snapshot_lolita.jpeg": 680,
	"./snapshot_lotea.jpeg": 395,
	"./snapshot_modern.jpeg": 189
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 958;